import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Card from "react-bootstrap/Card";
import { useNavigate, useParams } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { getAuth } from "firebase/auth";
import { useMemo } from "react";
import { useDocumentData } from "react-firebase-hooks/firestore";
import { getFirestoreZodConverter } from "../../modules/firestoreZodConverter";
import { projectDocumentSchema } from "../../types/firestore";
import { getFirestore, doc } from "firebase/firestore";
import User from "../../components/documents/user";
import LoadingAlert from "../../components/common/loadingAlert";

const auth = getAuth();
const firestore = getFirestore();

export default function DocumentsUsers() {
	const navigate = useNavigate();

	const [user, userLoading] = useAuthState(auth);

	if (!user && !userLoading) {
		navigate("/account");
	}

	const { projectId } = useParams();
	if (!projectId) throw "DocumentsUsers page requires a projectId parameter.";

	const projectDocumentRef = useMemo(
		() =>
			doc(firestore, "Projects", projectId).withConverter(
				getFirestoreZodConverter(projectDocumentSchema),
			),
		[projectId],
	);

	const [projectDocument, , projectDocumentError] = useDocumentData(projectDocumentRef);

	if (!user || !projectDocument) {
		return <LoadingAlert error={projectDocumentError} />;
	}

	const memberEntries = Object.entries(projectDocument.Members);

	return (
		<div>
			<div className="mb-2">
				<b>Benutzerdokumente</b>
			</div>
			<Card role="button" className="mb-2 clickable-card" onClick={() => navigate(-1)}>
				<Card.Body>
					<Row>
						<Col xs="auto">
							<i className="bi bi-arrow-left-circle fs-1" />
						</Col>
						<Col className="d-flex align-items-center">Zurück</Col>
					</Row>
				</Card.Body>
			</Card>
			{memberEntries.map(([userId, role]) => (
				<User key={userId} projectId={projectId} userId={userId} userRole={role} />
			))}
		</div>
	);
}
